<template>
  <section ref="anchor" class="success">
    <div class="success__content">
      <div
        v-for="(tile, index) in content.tiles"
        :key="index"
        :class="[
          'success__content-item',
          index > 3 ? 'mod-wide' : 'mod-narrow',
        ]"
      >
        <div class="success__content_header">
          <div class="font-24-30-bold success__content_title">
            {{ tile.title }}
          </div>

          <svg
            v-if="index < 3"
            class="success__content_arrow mod-desktop"
            viewBox="0 0 100 30"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- Линия -->
            <line
              x1="0"
              y1="11.5"
              x2="97"
              y2="11.5"
              stroke="#4CC0CC"
              stroke-width="3"
              vector-effect="non-scaling-stroke"
            />
            <!-- Стрелка -->
            <path
              d="M85 1.5 L100 11.5 L85 21.5"
              fill="none"
              stroke="#4CC0CC"
              stroke-width="3"
              vector-effect="non-scaling-stroke"
            />
          </svg>

          <svg
            v-if="index < 3"
            class="success__content_arrow mod-mobile"
            viewBox="0 0 25 105"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- Линия -->
            <line
              x1="12"
              y1="0"
              x2="12"
              y2="105"
              stroke="#4CC0CC"
              stroke-width="4"
              vector-effect="non-scaling-stroke"
            />
            <!-- Стрелка -->
            <path
              d="M2 98 L12 105 L22.5 98"
              fill="none"
              stroke="#4CC0CC"
              stroke-width="4"
              vector-effect="non-scaling-stroke"
            />
          </svg>
        </div>

        <div
          :class="['success__content-block', { 'mod-gray': tile.background }]"
        >
          <img
            v-if="tile.img"
            :src="`/img/${tile.img}`"
            class="success__content-image"
            alt=""
          />

          <div class="font-medium block__subtitle">
            {{ tile.subtitle }}
          </div>

          <div class="block__description">{{ tile.text }}</div>
        </div>
      </div>
    </div>

    <div class="success__info">
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="42" height="42" rx="12" fill="#4CC0CC" />
        <path
          d="M13.4878 21.9167L19.1841 26.1524C19.6278 26.4823 20.255 26.3896 20.5842 25.9454L28.5118 15.25"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>

      <div class="success__info_description">
        <div class="font-24-30-bold">{{ content.info.title }}</div>

        <div class="font-small">
          {{ content.info.description }}
        </div>
      </div>
    </div>

    <div class="font-16-22-gray details__content">
      <span>{{ content.info.details }}</span>
      <span class="text-blue" @click="$emit('details-clicked')">
        {{ ' Подробнее' }}
      </span>
    </div>
  </section>
</template>

<script>
import { electronicSuccessfullyCompletedData } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'

export default {
  name: 'ElectronicSuccessfullyCompleted',
  mixins: [offsetMixin],
  data() {
    return {
      content: electronicSuccessfullyCompletedData,
    }
  },
}
</script>

<style lang="sass" scoped>
.success
  padding: 0 $desktopHorizontalPaddings 8rem
  @media (max-width: 1023px)
    padding: 0 $mobileHorizontalPaddings 4rem
  &__content
    display: flex
    justify-content: space-between
    flex-wrap: wrap
    &-item
      display: flex
      flex-direction: column
    @media (max-width: 1023px)
      margin-top: 2.4rem
      &-item
        width: 100%
        display: flex
        flex-direction: row
        align-items: stretch
        height: auto
        gap: 20px
        margin-bottom: 1.2rem
        .success__content_title
          margin: 0
          flex-shrink: 0
        .success__content-block
          flex-grow: 1

    @media (min-width: 1024px)
      & .mod-wide
        width: 20.16vw
        min-height: 20.16vw

      & .mod-narrow
        width: 14.84vw
        min-height: 20.84vw
        margin-bottom: 2rem

    &-image
      margin: 0 auto
      padding-bottom: 0.8rem
      height: 60%
      max-width: 100%
      object-fit: contain
      @media (max-width: 1023px)
        margin: 0 0 1.6rem 0
        height: auto
        width: 100%
        max-height: 400px

    &-block
      display: flex
      flex-direction: column
      flex: 1
      @media (max-width: 1023px)
        height: auto
        justify-content: flex-start
      padding: 3.2rem 2.4rem
      border-radius: 20px
      border: 1px solid $backgroundGray
      @media (min-width: 1440px) and (max-width: 1599px)
        padding: 2.2rem 1.4rem
      @media (min-width: 1024px) and (max-width: 1439px)
        padding: 2.2rem 1.4rem
      @media (max-width: 1023px)
        padding: 1.6rem 1.4rem
      .block__description
        font-weight: 500
        @media (min-width: 1024px) and (max-width: 1439px)
          font-size: 1.6rem
        @media (max-width: 1023px)
          font-weight: 400
      &.mod-gray
        background: $backgroundGray
    &_title
      display: flex
      align-items: center
      justify-content: center
      margin: 0 0 30px
      background: #EDF1F2
      border-radius: 12px
      width: 4.2rem
      height: 4.2rem
      position: relative
      z-index: 2
    &_header
      position: relative
      display: flex
      align-items: center
      @media (min-width: 1024px)
        width: 100%
        justify-content: center
      @media (max-width: 1023px)
        flex-direction: column
        width: 4.2rem
        height: 100%
    &_arrow
      position: absolute
      z-index: 1
      fill: none
      stroke: #4CC0CC
      &.mod-desktop
        @media (max-width: 1023px)
          display: none
        @media (min-width: 1024px)
          display: block
          top: 2.1rem
          left: calc(50% + 2.1rem + 13px)
          width: calc(100% - 4.2rem - 26px)
          height: 23px
          transform: translateY(-50%)
      &.mod-mobile
        @media (min-width: 1024px)
          display: none
        @media (max-width: 1023px)
          display: block
          top: calc(4.2rem + 13px)
          left: 2.1rem
          width: 25px
          height: calc(100% - 4.2rem - 26px)
          transform: translateX(-50%)

.block__description
  font-family: $secondaryFont
  font-weight: 400
  font-size: 1.6rem
  line-height: 2.2rem
  color: $textSecondary
  @media (max-width: 1024px)
    font-size: 1.4rem
    line-height: 1.8rem

.block__subtitle
  font-family: $primaryFont
  font-weight: 400
  font-size: 2.2rem
  line-height: 3rem
  color: $textPrimary
  padding-bottom: 0.8rem
  @media (min-width: 1440px) and (max-width: 1699px)
    font-size: 2rem
  @media (min-width: 1024px) and (max-width: 1439px)
    font-size: 1.8rem
  @media (max-width: 1024px)
    font-size: 2rem
    line-height: 2.6rem

.success__info
  height: auto
  width: 100%
  padding: 32px
  background: #EBF8F9
  border-radius: 30px
  margin: 1rem auto 3rem
  display: flex
  gap: 2rem

  &_description
    display: flex
    flex-direction: column
    gap: 1rem

.text-blue
  color: $buttonPrimary
  font-weight: 500
  &:hover
    cursor: pointer

.details__content
  display: flex
  gap: 4px
  justify-content: left
  @media (max-width: 1024px)
    text-align: center
    flex-direction: column
    gap: 6px
</style>
